import * as yup from 'yup';

export interface FormValues {
  firstName: string;
  lastName: string;
}

export const validation = yup.object().shape({
  firstName: yup.string().required('Please specify a first name'),
});
